import {AfterViewInit, Component, ElementRef, Input, OnInit, Renderer2} from '@angular/core';
import {BehaviorSubject, combineLatest, Observable} from 'rxjs';
import {FondsService} from '../../../services/fonds.service';
import {MatTableDataSource} from '@angular/material/table';
import {ISymbol} from '@lv1871/core';
import {firstNestedSymbolControl, ListControl} from '../../../models/uiArtefakt';
import {UIAusrichtung} from '../../../models/uiAusrichtung';
import {ShellConfigService} from '../../../services/shell-config.service';
import {FondsMitAnteil} from '../../../models/fondsMitAnteil';
import {Fonds} from '../../../models/fonds';
import {map} from 'rxjs/operators';

@Component({
    selector: 'lv-ablaufmanagement',
    templateUrl: './ablaufmanagement.component.html',
    styleUrls: ['./ablaufmanagement.component.scss'],
    standalone: false
})
export class AblaufmanagementComponent implements OnInit, AfterViewInit {
  public showInfotextCollapsable: boolean = false;
  public uiAusrichtung: UIAusrichtung;
  public nestedSymbol: ISymbol;
  public ablaufmanagementFonds$: Observable<FondsMitAnteil>;
  public dataSource: MatTableDataSource<FondsMitAnteil>;
  private _uiArtefakt: ListControl;
  private _ablaufmanagementFondsliste$: BehaviorSubject<ListControl> = new BehaviorSubject<ListControl>(null);

  constructor(private _fondsService: FondsService, private _shellConfigService: ShellConfigService,
              private _renderer: Renderer2, private _element: ElementRef) {
  }

  get uiArtefakt(): ListControl {
    return this._uiArtefakt;
  }

  @Input() set uiArtefakt(uiArtefakt: ListControl) {
    this._uiArtefakt = uiArtefakt;
    this._ablaufmanagementFondsliste$.next(uiArtefakt);
  }

  ngAfterViewInit(): void {
    this._renderer.setAttribute(this._element.nativeElement, 'cypress-uuid', this.uiArtefakt.IdentifikatorUuid);
    if(!!this.uiArtefakt.ReferenzIdentifikator) {
      this._renderer.setAttribute(this._element.nativeElement, 'cypress-refId', this.uiArtefakt.ReferenzIdentifikator);
    }
  }

  ngOnInit(): void {
    this.uiAusrichtung = this._shellConfigService.getParameter().uiAusrichtung;
    this.nestedSymbol = firstNestedSymbolControl(this.uiArtefakt?.UIArtefakt);
    this.ablaufmanagementFonds$ = combineLatest<[Fonds[], ListControl]>([
      this._fondsService.getAllFonds(), this._ablaufmanagementFondsliste$]).pipe(
        map(([fonds, listControl]) => {
          const fondsMitAnteil = this._fondsService.getAnlaufAblaufmanagementFonds(fonds, listControl);
          this.dataSource = new MatTableDataSource([fondsMitAnteil]);
          return fondsMitAnteil;
        }));
  }

  public infotextCollapsableChange(event) {
    this.showInfotextCollapsable = event;
  }
}
